"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AUDITORIA_CANAIS_SOLICITACAO } from "@/lib/auditoriaCorrecao";

export interface SolicitacaoRastreioState {
  solicitadoPor: string;
  canal: string;
  referencia: string;
  solicitadoEm: string;
  motivo: string;
  observacoes: string;
}

interface Props {
  idPrefix: string;
  state: SolicitacaoRastreioState;
  onChange: (patch: Partial<SolicitacaoRastreioState>) => void;
}

export function SolicitacaoRastreioForm({ idPrefix, state, onChange }: Props) {
  return (
    <div className="rounded-lg border bg-muted/30 p-4 space-y-3">
      <p className="text-sm font-medium">Rastreio da solicitação</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor={`${idPrefix}-solicitado-por`}>
            Solicitado por <span className="text-destructive">*</span>
          </Label>
          <Input
            id={`${idPrefix}-solicitado-por`}
            placeholder="Ex.: Adriano Catarina — Financeiro"
            value={state.solicitadoPor}
            onChange={(e) => onChange({ solicitadoPor: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-canal`}>
            Por onde <span className="text-destructive">*</span>
          </Label>
          <Select value={state.canal} onValueChange={(canal) => onChange({ canal })}>
            <SelectTrigger id={`${idPrefix}-canal`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {AUDITORIA_CANAIS_SOLICITACAO.map((c) => (
                <SelectItem key={c.id} value={c.id}>
                  {c.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-solicitado-em`}>Data da solicitação</Label>
          <Input
            id={`${idPrefix}-solicitado-em`}
            type="datetime-local"
            value={state.solicitadoEm}
            onChange={(e) => onChange({ solicitadoEm: e.target.value })}
          />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor={`${idPrefix}-referencia`}>Referência (assunto do e-mail, protocolo…)</Label>
          <Input
            id={`${idPrefix}-referencia`}
            placeholder="Ex.: E-mail 07/05/2026 — Ajustes orçado"
            value={state.referencia}
            onChange={(e) => onChange({ referencia: e.target.value })}
          />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor={`${idPrefix}-motivo`}>Resumo curto</Label>
          <Input
            id={`${idPrefix}-motivo`}
            placeholder="Ex.: Reclassificar linha para Consultorias"
            value={state.motivo}
            onChange={(e) => onChange({ motivo: e.target.value })}
          />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor={`${idPrefix}-observacoes`}>
            Observações / texto do pedido <span className="text-destructive">*</span>
          </Label>
          <Textarea
            id={`${idPrefix}-observacoes`}
            placeholder="Cole o trecho do e-mail ou descreva o pedido."
            value={state.observacoes}
            onChange={(e) => onChange({ observacoes: e.target.value })}
            rows={4}
          />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        O sistema registra também quando a alteração foi aplicada e qual usuário logado executou.
      </p>
    </div>
  );
}
